<template>
  <div
    class="shutdown-banner"
    @click="goToBlog"
  >
    <div class="header">{{ headerCopy }}</div>
    <div class="description">
      <span class="description-content">
        {{ descriptionCopy }}
      </span>
      <span class="description-content content-mobile">
        {{ shortDescriptionCopy }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters("Util", ["hideGoProBanner"]),
    ...mapGetters("User", ["getUser", "isUserPro"]),
    ...mapGetters("Store", [
      "subscriptionOptions",
      "maxDiscount",
      "trialInitialInterval",
    ]),
    ...mapGetters("Optimizely", ["optimizelyData"]),
    headerCopy () {
      return "COACHING IS MOVING"
    },
    descriptionCopy () {
      return "ProGuides Coaching has moved to Coachify. You can continue to book sessions with a selection of ProGuides coaches on Coachify."
    },
    shortDescriptionCopy () {
      return "ProGuides Coaching has moved to Coachify starting June 30th."
    },
  },
  methods: {
    ...mapActions("Util", ["loadGoProBannerStatus"]),
    ...mapMutations("Util", ["setHideGoProBanner"]),
    ...mapActions("Store", ["getSubscriptionOptions"]),
    close () {
      this.setHideGoProBanner(true)
      window.localStorage.setItem("hide-main-navigation-cta-banner", true)
    },
    goToBlog (e) {
      if (e.target.className !== "close") {
        window.location.href = "https://support.aimlabs.com/hc/en-us/articles/21710950900887-ProGuides-Coaching-is-moving-to-Coachify"
        this.trackAnalyticsEvent("Clicked Shutdown Banner")
      }
    },
  },
  mounted () {
    this.loadGoProBannerStatus()
  },
  created () {
    this.getSubscriptionOptions()
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.shutdown-banner {
  cursor: pointer;
  position: fixed;
  width: 100%;
  height: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(rgb(228, 179, 52) 0px, rgb(249, 208, 103) 100%);
  top: 5.5rem;
  z-index: 8;
//  cursor: pointer;
  .header {
    font-family: Proxima Nova;
    font-size: 1.8rem;
    font-weight: 700;
    color: #3b3b3b;
    text-transform: capitalize;
    @include phone-down {
      font-size: 1.4rem;
      flex: none;
      margin-left: 1rem;
    }
  }
  .description {
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 89.6%;
    color: #3b3b3b;
    height: 3.5rem;
    display: flex;
    align-items: center;
    @include phone-down {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      border-left: 1px solid #3b3b3b;
      padding-left: 1.3rem;
      margin-left: 1.3rem;
      // max-width: 0%;
      @include phone-small {
        padding-left: 0.5rem;
        margin-left: 0.5rem;
        margin-right: 1rem;
      }
    }
    .description-content {
      height: 3.5rem;
      border-left: 1px solid #3b3b3b;
      display: flex;
      align-items: center;
      padding: 0 2.8rem;
      margin: 0 2.5rem;
      text-align: left;
      @include phone-down {
        font-size: 1.2rem;
        // line-height: 125.6%;
        border: none;
        margin: 0;
        padding: 0;
        max-width: 85%;
        display: none;
      }
      &.content-mobile {
        display: none;
        @include phone-down {
          display: flex;
        }
      }
      @include phone-small {
        font-size: 1.1rem;
        max-width: 90%;
      }
      strong {
        color: #ffc85f;
        font-style: normal;
        font-weight: 600;
      }
    }
  }
  .close {
    position: absolute;
    right: 1.6rem;
    top: 1.6rem;
//    cursor: pointer;
    padding: 0.5rem;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
    @include phone-small {
      right: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/banner/ShutdownBanner.vue